import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import { useBrowseLevelsLayoutContextValue } from "#browse-levels-layout-context-value";

export const BrowseLevelsLayoutContext = createContext(
  defaultError<ReturnType<typeof useBrowseLevelsLayoutContextValue>>("BrowseLevelsLayoutContext"),
);
